import LessonFormModal from "./LessonFormModal"

// La lezione di recupero di un corso annullato: una lezione nuova, come
// duplicandola, con gli abbonati che pagano col recupero
export function RescheduleLessonModal({ closeModal, lessonData }) {
	return <LessonFormModal mode="reschedule" closeModal={closeModal} lessonData={lessonData} />
}

export default RescheduleLessonModal
